import { isFlagEnabled as isFlagEnabledAF } from '@atlassian/teams';
import { getEnv } from '@atlassian/teams-common/context-config';

export enum FeatureFlag {
	//Teams in JSM Ops productFeatureFlags
	EVENT_ON_CALL_EFF = 'event-on-call-consolidation_s97c8',
	EVENT_ON_CALL_CONSOLIDATION_STATE = 'event-on-call-consolidation-state',

	// Control for Open Sites permissions check
	ENABLE_MOCK_OPEN_SITES_FAIL = 'ptc-directory-ui.deny-open-sites-in-fe',

	// Atlas
	DISABLE_ATLAS_CROSSWFLOW_ADS = 'disable_atlas_crossflow_ads',
}

// All feature flags must be listed here so that they can be selectively fetched from LaunchDarkly
// For real execution environments, configure flags in https://app.launchdarkly.com/ppl-teams-collective/test/features
// The default values here are used as the fallback when everything else (LD, local storage cache, local overrides) fails
const DEFAULT_FEATURE_FLAGS: FeatureFlagResult = {
	[FeatureFlag.ENABLE_MOCK_OPEN_SITES_FAIL]: false,
	[FeatureFlag.DISABLE_ATLAS_CROSSWFLOW_ADS]: false,
	[FeatureFlag.EVENT_ON_CALL_EFF]: false,
	[FeatureFlag.EVENT_ON_CALL_CONSOLIDATION_STATE]: false,
};

// Overrides only for local/CI environments
const LOCAL_OVERRIDE_FEATURE_FLAGS: Partial<FeatureFlagResult> = {
	// Features rolled out to 100%
	// Atlassian-only features
};

export const initialFeatureFlagList = (): {
	'event-on-call-consolidation_s97c8': boolean;
	'event-on-call-consolidation-state': boolean;
	'ptc-directory-ui.deny-open-sites-in-fe': boolean;
	disable_atlas_crossflow_ads: boolean;
} =>
	process?.env?.NODE_ENV === 'development' || getEnv() === 'local'
		? {
				...DEFAULT_FEATURE_FLAGS,
				...LOCAL_OVERRIDE_FEATURE_FLAGS,
			}
		: { ...DEFAULT_FEATURE_FLAGS };

type FeatureFlagResult = { [k in FeatureFlag]: boolean };

/**
 * @private
 * @deprecated - use useFeatureFlag or useBooleanFeatureFlag instead.
 * This method return best known flag value, but only compute values from Directory GraphQL,
 * local storage, and default values.
 *
 * Using this in React components should be avoided, as the component won't re-render when
 * feature flag values are loaded.
 */
export function isFlagEnabled(flag: FeatureFlag): boolean {
	return isFlagEnabledAF(flag);
}
